import { http } from "./client";
import type { TenantBilling, TenantBillingDetail } from "@/types/domain";

// "Billing & Subscription" - every tenant's subscription, platform-wide.
export const platformBillingApi = {
  overview: () => http.get<{ tenants: TenantBilling[] }>("/platform/billing").then((r) => r.tenants),

  // The "select a company" drill-down - one tenant's full subscription +
  // recent invoice history. See backend GetTenantBilling/PlatformTenantBilling.
  get: (tenantId: string) => http.get<TenantBillingDetail>(`/tenants/${tenantId}/billing`),
};
